export default {"src":"/_next/static/media/circleSmall.d9e54cc7.svg","height":28,"width":28};